import { makeStyles } from 'tss-react/mui'


export const useStyles = makeStyles()((theme) => {
    return {
        container: {
            position: 'fixed',
            height: '100%',
            width: '100%',
            zIndex: 1000000
        },
        tourCanvas: {
            width: '100%',
            height: '100%'
        },
        anchor: {
            position: 'fixed',
            visibility: 'hidden',
            pointerEvents: 'none'
        },
        tooltipBottomBar: {
            display: 'flex',
            justifyContent: 'space-between',
            borderTop: `1px solid ${theme.palette.grey[200]}`,
            borderRadius: '0 0 4px 4px',
            overflow: 'hidden'
        },
        tooltipContent: {
            padding: theme.spacing(0.5, 2, 2)
        },
        skipButton: {
            color: theme.palette.grey[500]
        },
        actionButtonsContainer: {
            display: 'flex',
            width: '50%',
            justifyContent: 'flex-end'
        },
        actionButton: {
            borderRadius: 0,
            width: '50%'
        }
    }
})